module.exports = __webpack_public_path__ + "static/media/github.bda81109.svg";